export default "__VITE_ASSET__b9751a70__"